const UserApiKeyCollectionFields = [
];

export default UserApiKeyCollectionFields;